export default __webpack_public_path__ + "static/media/25032810.067f0f08.jpg";